import React, { useState, useMemo } from "react";
import { DataTable, Badge, Pagination } from "@/components/ui";
import { fmt, fmtDate } from "@/lib/formatters";
import { Eye, Edit2, UserX } from "lucide-react";

export const MaterialExpensesTable = ({ expenses, onView, onEdit, onToggleDisable }) => {
  const [page, setPage] = useState(1);
  const limit = 10;

  const columns = [
    {
      header: "Date",
      accessor: (row) => (
        <div className="text-slate-600 !text-[10px] flex items-center whitespace-nowrap">
          {row.date ? fmtDate(row.date) : "—"}
        </div>
      ),
      minWidth: "90px",
    },
    {
      header: "SD Id",
      accessor: (row) => (
        <span className="text-[10px] uppercase tracking-tight whitespace-nowrap text-brand-blue font-medium">
          {row.sdId || row.expenseId || row.invoiceNo || "—"}
        </span>
      ),
      minWidth: "110px",
    },
    {
      header: "Store",
      accessor: (row) => (
        <span className="text-[12px] text-slate-600 truncate font-medium">
          {row.storeRef?.storeName || "—"}
        </span>
      ),
      minWidth: "120px",
    },
    {
      header: 'Customer Name',
      accessor: (row) => {
        const p = row.project || {};
        const fullName = p.customerName || `${p.firstName || ''} ${p.lastName || ''}`.trim() || row.clientName || '—';
        return (
          <span className="text-slate-600 !text-[12px] truncate max-w-[150px]" title={fullName}>{fullName}</span>
        );
      },
      minWidth: '150px',
    },
    {
      header: 'Contact',
      accessor: (row) => {
        const p = row.project || {};
        const phone = p.phoneNumber || p.phone || '—';
        return (
          <span className="text-slate-600 !text-[12px]">{phone}</span>
        );
      },
      minWidth: '120px',
    },
    {
      header: 'Customer Type',
      accessor: (row) => {
        const p = row.project || {};
        const cType = p.customerType || '—';
        return (
          <span className="text-slate-600 !text-[12px] capitalize">{cType}</span>
        );
      },
      minWidth: '120px',
    },

    {
      header: "Amount",
      accessor: (row) => (
        <div className="text-rose-500 !text-[10px] font-bold flex items-center">
          {fmt(row.amount || 0)}
        </div>
      ),
      minWidth: "110px",
    },
    {
      header: "Status",
      accessor: (row) => (
        <Badge status={row.status || "pending"} />
      ),
      minWidth: "100px",
    },
    {
      header: "Actions",
      accessor: (row) => {
        const isCancelled = row.status === 'cancelled';
        return (
          <div className="flex items-center justify-center">
            <button
              onClick={(e) => { e.stopPropagation(); onView && onView(row); }}
              className="p-1.5 text-slate-400 hover:text-brand-blue hover:bg-blue-50 rounded-lg transition-all"
              title="View Detail"
            >
              <Eye size={16} />
            </button>
          </div>
        );
      },
      minWidth: "60px",
    }
  ];

  const getRowClassName = (row) => {
    return row.status === 'cancelled' ? "opacity-50 grayscale saturate-0" : "";
  };

  const paginatedData = useMemo(() => {
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    return expenses.slice(startIndex, endIndex);
  }, [expenses, page, limit]);

  return (
    <div className="flex flex-col h-full bg-white rounded-lg shadow-sm border border-slate-200">
      <div className="flex-1 min-h-[400px]">
        <DataTable
          columns={columns}
          data={paginatedData}

          getRowClassName={getRowClassName}
          headerRowStyle={{ backgroundColor: '#475569', color: '#fff' }}
          headerCellStyle={{ color: '#fff' }}
        />
      </div>
      
      {expenses.length > 0 && (
        <Pagination
          page={page}
          totalPages={Math.ceil(expenses.length / limit)}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};




